import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteFlow from 'hooks/flows/useDeleteFlow';
import { Flow } from 'types';
import notificationHandler from 'utils/notifications';

const ModalFlowDelete = ({
  opened,
  flow,
  handleClose,
}: {
  opened: boolean;
  handleClose: () => void;
  flow: Flow;
}): JSX.Element => {
  const { mutate, isLoading } = useDeleteFlow();
  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    mutate(flow.flowId, {
      onSuccess: () => {
        successNotification('Flow delete success', `${flow.flowId} successfully deleted.`);
      },
      onError: error => {
        errorNotification('Flow delete failed', error.response?.data.message);
      },
      onSettled: () => {
        handleClose();
      },
    });
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete Flow</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${flow.name || flow.trigger} ${
          flow.notificationType
        } notification for ${flow.recipients}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalFlowDelete;
